import { combineReducers } from 'redux';
import project from './project/projectSlice';
import results from './project/resultsSlice';
import template from './template/templateSlice';

export default combineReducers({
    template,
    project,
    results,
});
